export default __webpack_public_path__ + "media/images/tele_rouge-1fcf8791a2862118147646e0c067fdad.png";